import DataHelper from "./DataHelper";

const QuickMenuData = {
    async get(branch_office, res){
        return await DataHelper.get(`quick-menu-admin/${branch_office}`,res)
    },
    async patch(branch_office, data, res){
        return await DataHelper.patch(data, `quick-menu-admin/${branch_office}`,res)
    },
    async changeIcon(branch_office, data, res) {
        return await DataHelper.uploadFile(data, `quick-menu-admin/${branch_office}`, res);
    }
};

export default QuickMenuData;


// WEBPACK FOOTER //
// ./src/data/QuickMenuData.js